import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  wrap: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  },
  tooltip: {
    '& .MuiTooltip-tooltip': {
      background: theme.palette.custom.background.tooltip,
      color: theme.palette.custom.text.dark,
      borderRadius: theme.borderRadius.md,
      padding: 8,
      marginBottom: '0 !important',
      maxWidth: 375,
    },
  },
  tooltipIcon: {
    fontSize: 16,
    color: theme.palette.custom.elements.accent,
  },
}));

export default useStyles;
